<template>
    <div class="grey-bg">
        <div class="message rich-text text-justify-t" v-html="helpShow.body">
        </div>
    </div>
</template>

<script>
export default {
    name: "show",
    data(){
        return{
            helpShow: ''
        }
    },
    created() {
        this.getHelpShow(this.$route.params.id)
    },
    methods:{
        // 获取帮助反馈
        getHelpShow(helpId){
            let _this = this
            let url = _this.$api.Contents + '/' + helpId
            _this.$http.get(url,true).then( res => {
                if(res.data.success){
                    _this.helpShow = res.data.data
                }
            } )
        }
    }
}
</script>

<style scoped>

</style>